import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { intlShape } from 'react-intl';

import StyledSelect from 'components/ui/Select/Select';

import { StyledSummaryContainer, StyledSummaryDescriptionContainer, StyledSummaryToolsContainer } from './BookingSearchSummary.styles';

const BookingSearchSummary = ({
  reference,
  noOfPnrsFound,
  departureDate,
  travelEndDate,
  departureDateFormat,
  departureStation,
  passengerName,
  passengerEmail,
  serviceName,
  onHoldExpiry,
  trainNumber,
  coach,
  seat,
  station,
  depArrDate,
  shouldShowBookingFilter = false,
  includeCancelled = false,
  setIncludeCancelled = () => null,
  intl: { formatMessage }
}) => {
  const resultsMsg = `${formatMessage({
    id: 'bookingSearchResults.summary.weFound'
  })} ${noOfPnrsFound} ${formatMessage({
    id: 'bookingSearchResults.summary.resultsFor'
  })}: `;

  const onHoldExpiryMsg = onHoldExpiry
    ? `${formatMessage({ id: 'bookingSearchResults.summary.onHoldExpiry' })} ${moment(onHoldExpiry).format('MMM YYYY')}; `
    : '';

  const referenceMsg = reference ? `${formatMessage({ id: 'bookingSearchResults.summary.reference' })} ${reference}; ` : '';

  const paxNameMsg = passengerName ? `${formatMessage({ id: 'bookingSearchResults.summary.passengerName' })} ${passengerName}; ` : '';

  const depArrDateMsg = depArrDate
    ? `${formatMessage({
        id: 'bookingSearchResults.summary.depArrDate'
      })} ${moment(depArrDate).format(departureDateFormat || 'ddd D MMM YYYY')}; `
    : '';

  const depDateMsg =
    departureDate && !travelEndDate
      ? `${formatMessage({
          id: 'bookingSearchResults.summary.departureDate'
        })} ${moment(departureDate).format(departureDateFormat || 'ddd D MMM YYYY')}; `
      : departureDate && travelEndDate
      ? `${formatMessage({
          id: 'searchBooking.travelDateFrom'
        })} = ${moment(departureDate).format(departureDateFormat || 'ddd D MMM YYYY')}; `
      : '';

  const travelEndDateMsg = travelEndDate
    ? `${formatMessage({
        id: 'searchBooking.travelDateTo'
      })} = ${moment(travelEndDate).format(departureDateFormat || 'ddd D MMM YYYY')}; `
    : '';

  const depStationMsg = departureStation
    ? ` ${formatMessage({
        id: 'bookingSearchResults.summary.departureStation'
      })} ${departureStation}; `
    : '';

  const stationMsg = station ? `${formatMessage({ id: 'bookingSearchResults.summary.station' })}= ${station}; ` : '';

  const emailMsg = passengerEmail ? `${formatMessage({ id: 'bookingSearchResults.summary.email' })} ${passengerEmail}; ` : '';

  const serviceNameMsg =
    serviceName || trainNumber
      ? `${formatMessage({ id: 'bookingSearchResults.summary.serviceName' })} ${serviceName || trainNumber}; `
      : '';

  const coachMsg = coach ? `${formatMessage({ id: 'bookingSearchResults.summary.coach' })} ${coach}; ` : '';
  const seatMsg = seat ? `${formatMessage({ id: 'bookingSearchResults.summary.seat' })} ${seat}; ` : '';

  const bookingResultMessage =
    resultsMsg +
    onHoldExpiryMsg +
    referenceMsg +
    paxNameMsg +
    depArrDateMsg +
    depDateMsg +
    travelEndDateMsg +
    depStationMsg +
    stationMsg +
    emailMsg +
    serviceNameMsg +
    coachMsg +
    seatMsg;

  const handleDropdownChange = (event) => setIncludeCancelled(event.target.value === 'true');

  return (
    <StyledSummaryContainer>
      <StyledSummaryDescriptionContainer>
        <h1 data-testid="booking-result-title">{formatMessage({ id: 'bookingSearchResults.summary.title' })}</h1>
        <span id="booking-result-message" data-testid="booking-result-message">
          {bookingResultMessage}
        </span>
      </StyledSummaryDescriptionContainer>
      {shouldShowBookingFilter ? (
        <StyledSummaryToolsContainer>
          <StyledSelect
            required
            name="booking-filter"
            value={includeCancelled.toString()}
            data-testid="booking-filter"
            data-cy="booking-filter"
            onChange={handleDropdownChange}
          >
            <option value="false">{formatMessage({ id: 'bookingSearchResults.confirmedBookingsOnly' })}</option>
            <option value="true">{formatMessage({ id: 'bookingSearchResults.includeCancelledBookings' })}</option>
          </StyledSelect>
        </StyledSummaryToolsContainer>
      ) : null}
    </StyledSummaryContainer>
  );
};

BookingSearchSummary.propTypes = {
  reference: PropTypes.string,
  noOfPnrsFound: PropTypes.number.isRequired,
  departureDate: PropTypes.string,
  travelEndDate: PropTypes.string,
  departureStation: PropTypes.string,
  departureDateFormat: PropTypes.string,
  passengerName: PropTypes.string,
  passengerEmail: PropTypes.string,
  serviceName: PropTypes.string,
  trainNumber: PropTypes.string,
  coach: PropTypes.string,
  seat: PropTypes.string,
  onHoldExpiry: PropTypes.string,
  station: PropTypes.string,
  depArrDate: PropTypes.string,
  shouldShowBookingFilter: PropTypes.bool,
  includeCancelled: PropTypes.bool,
  setIncludeCancelled: PropTypes.func,
  intl: intlShape
};
export default BookingSearchSummary;
